import { isNotNullOrUndef } from '../utils/isNotNullOrUndef';
class ComponentVideo extends HTMLElement {
    video = this.querySelector('video');
    placeholder = null;
    playIcon = null;
    playing = false;
    constructor() {
        super();
        this.addEventListener('click', () => {
            if (!isNotNullOrUndef(this.playIcon)) {
                this.playIcon = this.querySelector('[data-c-part="playIcon"]');
            }
            if (!isNotNullOrUndef(this.placeholder)) {
                this.placeholder = this.querySelector('[data-c-part="placeholder"]');
            }
            if (!this.playing && isNotNullOrUndef(this.video)) {
                this.video.play().catch(e => console.log(e));
                this.style.zIndex = '5';
                if (isNotNullOrUndef(this.placeholder)) {
                    this.placeholder.style.opacity = '0';
                    this.placeholder.style.pointerEvents = 'none';
                }
                if (isNotNullOrUndef(this.playIcon)) {
                    this.playIcon.style.opacity = '0';
                    this.playIcon.style.pointerEvents = 'none';
                }
                this.playing = true;
            }
        });
        this.video?.addEventListener('ended', () => {
            if (!isNotNullOrUndef(this.video))
                return;
            this.style.zIndex = '';
            if (isNotNullOrUndef(this.placeholder)) {
                this.placeholder.style.opacity = '1';
                this.placeholder.style.pointerEvents = '';
            }
            if (isNotNullOrUndef(this.playIcon)) {
                this.playIcon.style.opacity = '1';
                this.playIcon.style.pointerEvents = '';
            }
            this.playing = false;
        });
    }
}
customElements.define('video-component', ComponentVideo);
